import React from "react";
import { Chip } from "@mui/material";

import { JOB_STATUSES } from "../../constants";

const flow = {
  [JOB_STATUSES.NOT_STARTED]: "grey",
  [JOB_STATUSES.IN_PROGRESS]: "blue",
  [JOB_STATUSES.COMPLETE]: "mainFilled",
};
const OrderLineItemChip = ({
  state = JOB_STATUSES.NOT_STARTED,
  label = "",
}) => {
  const final = label || JOB_STATUSES.NOT_STARTED;
  return (
    <Chip
      label={final}
      variant="colorTag"
      flow={flow[state]}
      sx={{
        margin: "6px",
        "& .MuiChip-label": {
          fontSize: 10,
        },
      }}
    />
  );
};

export default OrderLineItemChip;
